import { SVGProps } from 'react';

/* eslint max-len: 0 */
export const ArrowDownTray = ( props: SVGProps<SVGSVGElement> ) => (
	<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' { ...props }>
		<path
			d='M12 3V16M12 16L16.5 11.5M12 16L7.5 11.5'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M3 16V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V16'
			strokeWidth='2'
			strokeLinecap='round'
		/>
	</svg>
);
